import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=8b2523de&"
import script from "./CompanyData.vue?vue&type=script&lang=js&"
export * from "./CompanyData.vue?vue&type=script&lang=js&"
import style0 from "./CompanyData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports